import React, {useRef, useEffect} from 'react';

import * as S from './SmartEngageUI.styles';
import useCarousel from '../../../../../shared/hooks/useCarousel';
import RightArrowNewIconHome from '../../../../../stories/Icons/ArrowRightNew';
import LeftArrowNewIcon from '../../../../../stories/Icons/ArrowLeftNew';

export interface IBannerData {
  banner_type?: number;
  img_url?: string;
  slug?: string;
  cta_type?: string;
  name?: string;
  cta_url?: string;
}

const SmartEngageCarousel = ({carouselDataList = [], applyFilterCta}) => {
  const {increment, decrement, isLeftCursorActive, isRightCursorActive, dataList} = useCarousel(
    carouselDataList,
    1,
  );

  const toShowBannerData = dataList[0] || {};
  const {filter, ctaUrl = '', image = ''} = toShowBannerData;
  return (
    <>
      {ctaUrl ? (
        <a href={ctaUrl} target="_blank" rel="noopener">
          <S.ImageBannerContainer src={image} alt={image} />
        </a>
      ) : (
        <S.ImageBannerOnClickContainer onClick={filter ? () => applyFilterCta(filter) : () => {}}>
          <S.ImageBannerContainer src={image} alt={image} />
        </S.ImageBannerOnClickContainer>
      )}

      {!!isRightCursorActive && (
        <S.SliderArrowRight
          onClick={() => {
            increment();
          }}
        >
          <RightArrowNewIconHome />
        </S.SliderArrowRight>
      )}

      {!!isLeftCursorActive && (
        <S.SliderArrowLeft
          onClick={() => {
            decrement();
          }}
        >
          <LeftArrowNewIcon />
        </S.SliderArrowLeft>
      )}
    </>
  );
};

const SmartEngageUI = ({dataList = [], applyFilterCta}) => {
  const dataListRef = useRef(dataList);

  useEffect(() => {
    dataListRef.current = dataList;
  }, [dataList]);

  if (!dataListRef.current.length) {
    return null;
  }
  return (
    <SmartEngageCarousel carouselDataList={dataListRef.current} applyFilterCta={applyFilterCta} />
  );
};

export default SmartEngageUI;
